export const fieldOptionListVariableName = (fieldName) => `options_${fieldName}`;
export const fieldOptionSelectedVariableName = (fieldName) => `optionselected_${fieldName}`;
export const fieldOptionFilterVariableName = (fieldName) => `optionfilter_${fieldName}`;
export const fieldSearchServiceName = (fieldName) => `search_${fieldName}`;
export const fieldClickServiceName = (fieldName) => `click_${fieldName}`;
export const servicePendingName = (serviceNamespace, serviceName) => `${serviceNamespace}_Service_${serviceName}_Pending`;
export { unstable_batchedUpdates as batch } from "react-dom";
//# sourceMappingURL=utils.js.map